export default __webpack_public_path__ + "static/media/646bf525daf1edeb9950b56b77642fa3.7986ed82.svg";